export const buildNumber = '20260612.6';
export const version = 'main';
export const latestCommit = '89153740fa321dec0050925918a0fe7a4d1e2f19';
